import axios from "axios";

import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const BASE_ANEXOII2 = `${API_URL}/concursos/anexoII2`;
const BASE_ANEXOI2 = `${API_URL}/concursos/anexoI2`;
const GET_PDF_SOLICITUD_CONCURSO1 = `${API_URL}/jasper/generarPDF_solicitudesConcursoAnexo1`;
const GET_PDF_SOLICITUD_CONCURSO2 = `${API_URL}/jasper/generarPDF_solicitudesConcursoAnexo2`;
const GET_CONCURSOS = `${API_URL}/concursos`;
const INSERT_SOLICITUD_CONCURSO_ANEXOII1 = `${API_URL}/concursos/anexoII1/insertSolicitud`;
const INSERT_SOLICITUD_CONCURSO_ANEXOI1 = `${API_URL}/concursos/anexoI1/insertSolicitudLaborales`;
const UPDATE_SOLICITUD_CONCURSO_ANEXOI1 = `${API_URL}/concursos/anexoI1`;
const UPDATE_SOLICITUD_CONCURSO_ANEXOII1 = `${API_URL}/concursos/anexoII1`;
const GET_PROVINCIAS = `${API_URL}/concursos/obtenerProvincias`;
const GET_LOCALIDADES = `${API_URL}/concursos/obtenerLocalidades`;
const GET_USER = `${API_URL}/concursos/obtenerDatosUsuario`;
const LISTADO_EN_PLAZO = `${API_URL}/concursos/listadoSolicitudes`;
const LISTADO_FUERA_PLAZO = `${API_URL}/concursos/listadoSolicitudesFueraPlazo`;
const GET_SOLICITUD_ID = `${API_URL}/concursos/obtenerSolicitudPorCod`;
const GET_PUESTOS_F = `${API_URL}/concursos/anexoII2/obtenerListadoPuestosF`;
const GET_PUESTOS_L = `${API_URL}/concursos/anexoI2/obtenerListadoPuestosL`;
const GET_PUESTOS = `${API_URL}/concursos/anexoII2`;
const GET_CENTROS = `${API_URL}/concursos/anexoI2/obtenerCentrosLaborales`;
const GET_PUESTOS_SELECCIONADOS = `${API_URL}/concursos/anexoII2`;
const GET_CENTROS_SELECCIONADOS = `${API_URL}/concursos/anexoI2`;
const GET_PUESTOS_L_CONV_M = `${API_URL}/concursos/anexoII2/obtenerListadoPuestosLConvocatoriaM`
const GET_CENTROS_L_OTRAS_CONV = `${API_URL}concursos/anexoI2/obtenerListadoCentrosAdscripcionLOtrasConvocatorias`
const VALIDA_SOLICITUD = `${API_URL}/concursos/validaSolicitud`;
const BORRA_SOLICITUD = `${API_URL}/concursos/borraSolicitud`;
const INSERT_REQUISITOS = `${API_URL}/concursos/insertAlegacionRequisitosFormacion`;
const GET_LISTADO_REQUISITOS = `${API_URL}/concursos/anexoII3/getListadoRequisitosFormacion`;
const GET_LISTADO_TITULACIONES = `${API_URL}/concursos/anexoII3/getListadoTitulaciones`;
const GET_LISTADO_AREA_FORMATIVA = `${API_URL}/concurso/getListadoAreaFormativa`;
const GET_LISTADO_AREA_FORMATIVAII4 = `${API_URL}/concursos/anexoII4/getListadoAreaFormativa`;
const GET_SELECT_TITULACIONESII4 = `${API_URL}/concursos/anexoII4/getTitulaciones`;
const GET_LISTADO_IDIOMAS_MERITOSII4 = `${API_URL}/concursos/anexoII4/getIdiomasYotros`;
const GET_LISTADO_TIPOS_PUBLICACIONESII4 = `${API_URL}/concursos/anexoII4/getTiposPublicaciones`;
const GRABAR_ANEXOII4 = `${API_URL}/concursos/anexoII4`;
const GRABAR_ANEXOI3 = `${API_URL}/concursos/anexoI3`


const GET_LISTADO_AREA_FORMATIVAI3 = `${API_URL}/concursos/anexoI3/getListadoAreaFormativa`;
const GET_SELECT_TITULACIONESI3 = `${API_URL}/concursos/anexoI3/getTitulaciones`; //no se usa
const GET_LISTADO_IDIOMAS_MERITOSI3 = `${API_URL}/concursos/anexoI3/getIdiomasYotros`;
const GET_LISTADO_TIPOS_PUBLICACIONESI3 = `${API_URL}/concursos/anexoI3/getTiposPublicaciones`;

const GET_LISTADO_TITULACIONES_MERITO = `${API_URL}/concursos/anexoII4/getListadoRequisitosFormacion`;
const GET_LISTADO_IDIOMA_MERITO = `${API_URL}/concursos/anexoII4/getListadoRequisitosFormacion`;
const GET_LISTADO_TIPO_PUBLICACION_MERITO = `${API_URL}/concursos/anexoII4/getListadoRequisitosFormacion`;
const GET_MERITOS = `${API_URL}/concursos/anexoII4/getIdiomasYotros`;
const GET_CERTIFICADO_REGISTROS = `${API_URL}/concursos/certificadoRegistro`;
const GET_CERTIFICADO_EDUCACION = `${API_URL}/concursos/certificadoEducacion`;
const GET_CERTIFICADO_AGRICULTURA = `${API_URL}/concursos/certificadoAgricultura`;
const GET_CERTIFICADO_EXPERIENCIA = `${API_URL}/concursos/certificadoExperiencia`;
const GET_PDF_EDUCACION = `${API_URL}/concursos/imprimeCertificadoEducacion`;
const GET_DATOS_DESTINO_POR_SOLICITUD = `${API_URL}/concursos/anexoI1/obtenerDatosDestinoPorSolicitud`;
const GET_DATOS_DESTINO_POR_DNI = `${API_URL}/concursos/anexoI1/obtenerDatosDestinoPorDNI`;
const GET_TIPO_CONVOCATORIA = `${API_URL}/concursos/obtenerTipoConvocatoriaConcurso`
const GET_PDF_SOLICITUD_CONCURSO = `${API_URL}/concursos/obtenerPDFSolicitudAnexoII`;
const GUARDAR_ORDEN_PUESTOS = `${API_URL}/concursos/anexoII2/guardarOrdenPuestos`
const GUARDAR_ORDEN_CENTROS = `${API_URL}/concursos/anexoI2/guardarOrdenCentros`
const GET_GRUPO_CATEGORIA_SITUACION = `${API_URL}/concursos/anexoI1/obtenerGrupoCategoriaSituacion`
const GET_DATOS_DESTINO = `${API_URL}/concursos/anexoI1/obtenerDatosDestino`
const GET_EXCLUSIONES = `${API_URL}/concursos/anexoI2/obtenerExclusiones`

const GET_SITADMIN = `${API_URL}/concursos`

export async function getListaConcursos() {
  return await axios({
    method: "GET",
    url: `${GET_CONCURSOS}/`,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error:"));
}

export async function getConcursosById(id) {
  return await axios({
    method: "GET",
    url: `${GET_CONCURSOS}/${id}`,
  })
    .then((response) => response.data)
    .catch("Error:");
}

export async function getListaSolicitudesConcursos(
  id,
  fechaInicial,
  fechaFinal
) {
  return await axios({
    method: "GET",
    url: `${GET_CONCURSOS}/${id}/solicitudes`,
    params: {
      fechaIni: fechaInicial,
      fechaFinal: fechaFinal,
    },
  })
    .then((response) => response.data)
    .catch("Error:");
}

export async function getPDFSolicitudConcurso1(xSolicitud) {
  // 
  // enviar parametros como dni por e.j. para realizar la query en el back

  return await axios({
    method: "GET",
    url: `${GET_PDF_SOLICITUD_CONCURSO1}/${xSolicitud}`,
    responseType: "blob",
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error:"));
}

export async function getPDFSolicitudConcurso2(xSolicitud) {
  // 
  // enviar parametros como dni por e.j. para realizar la query en el back

  return await axios({
    method: "GET",
    url: `${GET_PDF_SOLICITUD_CONCURSO2}/${xSolicitud}`,
    responseType: "blob",
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error:"));
}

export async function insertSolicitudConcursoAnexoI1(anexoI1, codConcurso) {
  
  return await axios({
    method: "POST",
    url: `${INSERT_SOLICITUD_CONCURSO_ANEXOI1}/${codConcurso}`,
    data: anexoI1,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en intentar insertar el borrador")
    );
}
export async function insertSolicitudConcursoAnexoII1(valores) {
  
  if (valores.niep.length === 9) {
    valores.niep = valores.niep.substr(0, valores.dni.length - 1);
  }
  return await axios({
    method: "POST",
    url: INSERT_SOLICITUD_CONCURSO_ANEXOII1,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en intentar insertar el borrador")
    );
}

export async function updateSolicitudConcursoAnexoI1(valores, id) {
  return await axios({
    method: "PUT",
    url: `${UPDATE_SOLICITUD_CONCURSO_ANEXOI1}/${id}`,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en intentar actualizar el borrador")
    );
}
export async function updateSolicitudConcursoAnexoII1(valores, id) {
  return await axios({
    method: "PUT",
    url: `${UPDATE_SOLICITUD_CONCURSO_ANEXOII1}/${id}`,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en intentar actualizar el borrador")
    );
}

export async function obtenerProvincias() {
  return await axios({
    method: "GET",
    url: GET_PROVINCIAS,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en intentar obtener las provincias")
    );
}

export async function obtenerLocalidades(codProvincia) {
  return await axios({
    method: "GET",
    url: `${GET_LOCALIDADES}/${codProvincia}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en intentar obtener las localidades")
    );
}

export async function obtenerDatosUsuario() {
  return await axios({
    method: "GET",
    url: GET_USER,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en intentar obtener los datos de usuario")
    );
}

export async function obtenerListadoSolicitudesEnPlazo(cnvoXcabpro) {
  return await axios({
    method: "GET",
    url: `${LISTADO_EN_PLAZO}/${cnvoXcabpro}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las solicitudes realizadas")
    );
}

export async function obtenerListadoSolicitudesFueraPlazo(cnvoXcabpro) {
  return await axios({
    method: "GET",
    url: `${LISTADO_FUERA_PLAZO}/${cnvoXcabpro}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las solicitudes realizadas")
    );
}

export async function obtenerSolicitudPorCod(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_SOLICITUD_ID}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de la solicitud")
    );
}

export async function getPuestos(codConcurso, xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_PUESTOS}/${codConcurso}/${xSolicitud}/puestos`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function getCentros(codConcurso, xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_CENTROS}/${codConcurso}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los centros")
    );
}

export async function getPuestosSeleccionados(codConcurso, xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_PUESTOS_SELECCIONADOS}/${codConcurso}/${xSolicitud}/puestoSeleccionado`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function getCentrosSeleccionados(codConcurso, xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_CENTROS_SELECCIONADOS}/${codConcurso}/${xSolicitud}/centroSeleccionado`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los centros")
    );
}

export async function obtenerListadoPuestosFPuestos(xSolicitud, codConcurso, tipoConvocatoria) {
  return await axios({
    method: "GET",
    url: `${GET_PUESTOS_F}/${xSolicitud}/${codConcurso}/${tipoConvocatoria}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function obtenerListadoPuestosAdscripcionLConvM(xSolicitud, codConcurso, tipoConvocatoria) {
  return await axios({
    method: "GET",
    url: `${GET_PUESTOS_L_CONV_M}/${xSolicitud}/${codConcurso}/${tipoConvocatoria}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function obtenerListadoPuestosLCentros(xSolicitud, codConcurso) {
  return await axios({
    method: "GET",
    url: `${GET_PUESTOS_L}/${xSolicitud}/${codConcurso}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function obtenerListadoCentrosAdscripcionLOtrasConv(xSolicitud, codConcurso, tipoConvocatoria) {
  return await axios({
    method: "GET",
    url: `${GET_CENTROS_L_OTRAS_CONV}/${xSolicitud}/${codConcurso}/${tipoConvocatoria}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function eliminarPuestos(codConcurso, xSolicitud, idsAEliminar) {
  return await axios({
    method: "DELETE",
    url: `${BASE_ANEXOII2}/${codConcurso}/${xSolicitud}/puesto/eliminar`,
    data: idsAEliminar,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function eliminarCentros(codConcurso, xSolicitud, idsAEliminar) {
  return await axios({
    method: "DELETE",
    url: `${BASE_ANEXOI2}/${codConcurso}/${xSolicitud}/centro/eliminar`,
    data: idsAEliminar,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function reodenarPuestos(codConcurso, xSolicitud, listaOrdenPuestos) {
  return await axios({
    method: "PUT",
    url: `${BASE_ANEXOII2}/${codConcurso}/${xSolicitud}/reordenar/`,
    data: listaOrdenPuestos,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function reodenarCentros(codConcurso, xSolicitud, listaOrdenPuestos) {
  return await axios({
    method: "PUT",
    url: `${BASE_ANEXOI2}/${codConcurso}/${xSolicitud}/reordenar/`,
    data: listaOrdenPuestos,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los centros")
    );
}

export async function guardarOrdenPuestos(listaOrdenPuestos, params) {
  return await axios({
    method: "PUT",
    url: `${GUARDAR_ORDEN_PUESTOS}/${params.idCon}/${params.idSol}`,
    data: listaOrdenPuestos,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function guardarOrdenCentros(listaOrdenPuestos, params) {
  return await axios({
    method: "PUT",
    url: `${GUARDAR_ORDEN_CENTROS}/${params.idCon}/${params.idSol}`,
    data: listaOrdenPuestos,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function obtenerListaExclusiones(params) {
  return await axios({
    method: "GET",
    url: `${GET_EXCLUSIONES}/${params.idCon}`,

  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de las exclusiones")
    );
}

export async function validaSolicitud(xSolicitud) {
  return await axios({
    method: "PUT",
    url: `${VALIDA_SOLICITUD}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la validacion de la solicitud")
    );
}

export async function getSolicitudPDFConcursos(idCon, idSol) {
  return await axios({
    method: "GET",
    url: `${GET_PDF_SOLICITUD_CONCURSO}/${idCon}/${idSol}`,
    responseType: "blob",
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}
export async function borraSolicitud(xSolicitud) {
  return await axios({
    method: "DELETE",
    url: `${BORRA_SOLICITUD}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al borrar la solicitud")
    );
}

export async function insertRequisitosAnexoII3(valores) {
  
  return await axios({
    method: "POST",
    url: INSERT_REQUISITOS,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en la obtención de los puestos")
    );
}

export async function getListadoRequisitosFormacion(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_REQUISITOS}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los tipos de experiencia o requisitos de formación.")
    );
}

export async function getListadoTitulacionesAcademicas(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_TITULACIONES}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las titulaciones académicas")
    );
}

export async function getListadoAreaFormativa(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_AREA_FORMATIVA}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las areas formativas")
    );
}

export async function getListadoAreaFormativaII4(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_AREA_FORMATIVAII4}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención del listado de areas formativas")
    );
}

export async function getListadoAreaFormativaI3(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_AREA_FORMATIVAI3}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención del listado de areas formativas")
    );
}

export async function getSelectTitulacionesII4(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_SELECT_TITULACIONESII4}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las titulaciones académicas")
    );
}

export async function getSelectTitulacionesI3(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_SELECT_TITULACIONESI3}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las titulaciones académicas")
    );
}

export async function getSelectIdiomasYOtrosMeritosII4(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_IDIOMAS_MERITOSII4}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de idiomas y otros meritos")
    );
}

export async function getSelectIdiomasYOtrosMeritosI3(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_IDIOMAS_MERITOSI3}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de idiomas y otros meritos")
    );
}

export async function getSelectTiposPublicacionII4(xsolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_TIPOS_PUBLICACIONESII4}/${xsolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los tipos de publicación")
    );
}

export async function getSelectTiposPublicacionI3(xsolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_TIPOS_PUBLICACIONESI3}/${xsolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los tipos de publicación")
    );
}

export async function grabarAnexoII4(datosAnexo, codConcurso, xsolicitud) {
  return await axios({
    method: "POST",
    url: `${GRABAR_ANEXOII4}/${codConcurso}/${xsolicitud}`,
    data: datosAnexo
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la en el guardado del anexo II4")
    );
}

export async function grabarAnexoI3(datosAnexo, codConcurso, xsolicitud) {
  return await axios({
    method: "POST",
    url: `${GRABAR_ANEXOI3}/${codConcurso}/${xsolicitud}`,
    data: datosAnexo
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la en el guardado del anexo II4")
    );
}

export async function getTitulacionesMerito(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_TITULACIONES_MERITO}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las titulaciones académicas")
    );
}

export async function getIdiomasMerito(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_IDIOMA_MERITO}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las titulaciones académicas")
    );
}

export async function getTipoDePublicacionMérito(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_LISTADO_TIPO_PUBLICACION_MERITO}/${xSolicitud}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de las titulaciones académicas")
    );
}

//Recoge los datos para rellenar el combo de meritos y otros idiomas
export async function getIdiomasYotros(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_MERITOS}`,
    params: { xsolicitud: xSolicitud },
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los idiomas y otros meritos para rellenar el combo")
    );
}

export async function getCertificadosRegistros(cnvoxcabpro, niep, plazo) {
  return await axios({
    method: "GET",
    url: `${GET_CERTIFICADO_REGISTROS}/${cnvoxcabpro}/${niep}/${plazo}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los certificados de la solicitud")
    );
}

export async function getCertificadosEducacion(cnvoxcabpro, niep) {
  return await axios({
    method: "GET",
    url: `${GET_CERTIFICADO_EDUCACION}/${cnvoxcabpro}/${niep}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los certificados de la solicitud")
    );
}

export async function getCertificadosExperiencia(cnvoxcabpro, niep) {
  return await axios({
    method: "GET",
    url: `${GET_CERTIFICADO_EXPERIENCIA}/${cnvoxcabpro}/${niep}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los certificados de la solicitud")
    );
}

export async function getCertificadosAgricultura(cnvoxcabpro, niep) {
  return await axios({
    method: "GET",
    url: `${GET_CERTIFICADO_AGRICULTURA}/${cnvoxcabpro}/${niep}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
      (response.data =
        "Error: Fallo en la obtención de los certificados de la solicitud")
    );
}

export async function getPDFEducacion(nombreArchivo) {
  return await axios({
    method: "GET",
    url: `${GET_PDF_EDUCACION}/${nombreArchivo}`,

    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en recoger el PDF de educacion")
    );
}

export async function getDatosDestinoPorSolicitud(xSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_DATOS_DESTINO_POR_SOLICITUD}/${xSolicitud}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en recoger los datos del destino por solicitud")
    );
}

export async function getDatosDestinoPorDNI() {
  return await axios({
    method: "GET",
    url: `${GET_DATOS_DESTINO_POR_DNI}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en recoger los datos del destino por DNI")
    );
}

export async function obtenerTipoConvocatoriaPorConcurso(cnvoxcabpro) {
  return await axios({
    method: "GET",
    url: `${GET_TIPO_CONVOCATORIA}/${cnvoxcabpro}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en recoger los datos del tipo de convocatoria")
    );
}


export async function obtenerGrupoCategoriaSituacion(niep) {
  return await axios({
    method: "GET",
    url: `${GET_GRUPO_CATEGORIA_SITUACION}/${niep}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Error al obtener el grupo, categoria y situacion")
    );
}

export async function obtenerDatosDestino() {
  return await axios({
    method: "GET",
    url: GET_DATOS_DESTINO,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Error al obtener el grupo, categoria y situacion")
    );
}

export async function imprimirSolicitud(codConcurso, codSolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_CONCURSOS}/${codConcurso}/${codSolicitud}/imprimir`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Error al obtener el grupo, categoria y situacion")
    );
}

export async function generarReporte() {

  try {
    const params = new URLSearchParams({
      rep_sirhus_t: "",
      report: "/mnt/nasc2n/SIRHUSx/bin/rep/IF62VW.rdf",
      userid: "empleado/TRABEMP@TRSIRH1.world",
      destype: "cache",
      desformat: "pdf",
      DNI: "08815914",
      P_X_CONVOCATORIA: "342410",
      P_X_SOLICITUD: "1707110",
    });

    const response = await axios.post(
      "http://prusirhus.acaex.es/reports/rwservlet",
      params,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        responseType: "blob", // 👈 necesario para descargar PDF
      }
    );

    // Crear un enlace temporal para descargar el archivo
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = "reporte.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    
  } catch (error) {
    // // console.error("❌ Error al generar el reporte:", error);
  }

}
export async function obtenerAnexoI3(xsolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_CONCURSOS}/anexoI3/obtenerAnexoI3/${xsolicitud}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Error al obtener el grupo, categoria y situacion")
    );
}
export async function obtenerAnexoII4(xsolicitud) {
  return await axios({
    method: "GET",
    url: `${GET_CONCURSOS}/anexoII4/obtenerAnexoII4/${xsolicitud}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Error al obtener el grupo, categoria y situacion")
    );
}

export async function obtenerSituacionAdministrativa(codGrupo, codCuerpo) {
  

  return await axios({
    method: "GET",
    url: `${GET_SITADMIN}/${codGrupo}/${codCuerpo}/obtenerSituacionAdministrativa`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Error al obtener el grupo, categoria y situacion")
    );
}

export async function visualizarSeccionConcursos() {
  return await axios({
    method: "GET",
    url: `${GET_CONCURSOS}/visualizar`
  })
    .then((response) => response.data)  
    .catch(
      (response) => (response.data = "Error: Error al obtener el grupo, categoria y situacion")
    );
} 
